import script from "./GrScrollTop.vue?vue&type=script&setup=true&lang=js"
export * from "./GrScrollTop.vue?vue&type=script&setup=true&lang=js"

import "./GrScrollTop.vue?vue&type=style&index=0&id=1c9cfa41&lang=scss"

const __exports__ = script;

export default __exports__